export default __webpack_public_path__ + "static/media/arrow-down.ec2db1cc.svg";